module.exports = ".attachment-table{\r\n    width:60%;\r\n}\r\n\r\n.attachment-table td{\r\n    padding:5px;\r\n    vertical-align: middle;\r\n}\r\n\r\n/* .attachment-table td:nth-child(odd){\r\n    width:100px !important;\r\n} */\r\n\r\n.attachment-table td a{\r\n    display: inline-block;\r\n    padding: 5px;\r\n    margin-left: 50px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/issues/external-issues-details/external-issues-details.component.css
// module id = ./src/app/issues/external-issues-details/external-issues-details.component.css
// module chunks = main